setPaytrackProcessing